import type { HomeLoanRatesActions } from "./types";

export const fetchHomeLoanRates = (): HomeLoanRatesActions => ({
  type: "REQUEST_HOME_LOAN_RATES_DATA",
});

export const fetchHomeLoanRatesFailed = (): HomeLoanRatesActions => ({
  type: "REQUEST_HOME_LOAN_RATES_DATA_FAILED",
});

export const fetchHomeLoanRatesSuccess = (
  payload: Array<any>
): HomeLoanRatesActions => ({
  type: "REQUEST_HOME_LOAN_RATES_DATA_SUCCESS",
  payload,
});
